<!-- Portada pública (solo lectura) -->
<div class="public-card" *ngIf="loaded" [style.--accent]="accentColor">
  <!-- COVER -->
  <div
    class="cover"
    [ngStyle]="{
      'background-color': !frontPageUrl ? (color || defaultColor) : null
    }"
  >
    <img *ngIf="frontPageUrl" [src]="frontPageUrl" alt="Portada" class="cover__img" />
    <div class="cover__overlay"></div>
  </div>

  <!-- CUERPO -->
  <div class="body">
    <!-- Avatar + Nombre + Acciones (grid responsive) -->
    <div class="headline">
      <div class="avatar-wrap">
        <img class="avatar" [src]="avatarUrl || fallbackAvatar" alt="Avatar" />
      </div>

      <div class="title-wrap">
        <h1 class="title">
          {{ hasPublicName ? publicName : defaultTitle }}
          <button
            class="text-blue-600 text-sm border border-blue-600 px-3 py-1 rounded-full hover:bg-blue-50 transition"
            [ngStyle]="{
              'color': !frontPageUrl ? (color || defaultColor) : null
            }"
            >
            <i class="text-[20px] bx bx-badge-check"></i>
          </button>
        </h1>

        <!-- Subfila chips: doc si llega -->
        <div class="chips" *ngIf="hasDocument">
          <span class="chip">{{ (documentType || '') | uppercase }} {{ documentNumber }}</span>
        </div>

        <!-- Meta fila (solo lo que exista) -->
        <div class="meta">
          <ng-container *ngIf="hasWebPage">
            <span class="dot"></span>
            <a class="link" [href]="webPage" target="_blank">{{ webPage }}</a>
          </ng-container>
          <ng-container *ngIf="hasEmail">
            <span class="dot"></span>
            <a class="link" [href]="'mailto:' + email">{{ email }}</a>
          </ng-container>
          <ng-container *ngIf="hasPhone">
            <span class="dot"></span>
            <span>{{ contactMobile }}</span>
          </ng-container>
          <ng-container *ngIf="hasAddress">
            <span class="dot"></span>
            <span>{{ address }}</span>
          </ng-container>
          
        </div>

        <div class="warn" *ngIf="isDefault">
          Este usuario no tiene información pública disponible.
        </div>
      </div>

      <!-- Acciones -->
      <div class="actions" *ngIf="isSimulaCredito">
        <button type="button" class="btn btn-primary" (click)="openCreditDialog()">
          Simular Crédito
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Loading -->
<div class="loading" *ngIf="!loaded">Cargando…</div>